var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showFloatBtn)?_c('div',{class:_vm.b()},[(_vm.lightsData)?_c('Highlights',{ref:"highlights",attrs:{"lights-data":_vm.lightsData}}):_vm._e(),(_vm.showGuideMenu)?_c('LightBulb',{attrs:{"lights-data":_vm.lightsData}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }